import React from 'react';
import ScheduleV6Page from './components/ScheduleV6Page';
import { useBootstrapLaborClassifications } from 'store/laborClassifications';
import './styles.scss';

/**
 * Entry point for the new v6-based schedule page.
 *
 * This component is intentionally thin and only wires
 * the high-level container. All logic should live in
 * the components under ./components.
 */
const ScheduleV6 = () => {
  useBootstrapLaborClassifications();
  return <ScheduleV6Page />;
};

export default ScheduleV6;

